//export const encryptionKey = 'base64:3OpO5rPMGxzXDZj+dwUQWhgoUpMayHvOXsZf/cfERlM=';
// const appKeyBase64 = '3OpO5rPMGxzXDZj+dwUQWhgoUpMayHvOXsZf/cfERlM=';
// const appKey = atob(appKeyBase64);
// export const encryptionKey = appKey;
export const encryptionKey = "jGLXgOLFqvFLpl5dwRZUptgW/eS65SMZ9lKtx9/uZbo=";